import React from 'react';

import {
  LayoutPageHeading,
  LayoutCardSize,
  LayoutCardType,
  LayoutDynamicZone,
} from 'src/modules/layout';
import { LayoutDynamicZoneComponentTypes } from 'src/modules/layout/components/dynamicZone/LayoutDynamicZone';
import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { useIntl } from 'react-intl';
import { PagesStore, PageEntity } from 'src/modules/pages';
import { Row } from 'antd';
import { useLocale } from 'src/modules/locale';
import { defaultHorizontalGutter } from 'src/utils/grid';

interface ProfessionalsDownloadsListingPageProps extends PagesStore {
  page?: PageEntity;
}

const ProfessionalsDownloadsListingPage: React.FunctionComponent<ProfessionalsDownloadsListingPageProps> = (
  props
) => {
  const intl = useIntl();
  const { getLocalizedObject } = useLocale();

  if (!props?.page) return null;

  const pageProperties = {
    title: intl.formatMessage({ id: 'page/professionals/downloads/listing/head/page_title' }),
    description: intl.formatMessage({
      id: 'page/professionals/downloads/listing/head/meta_description',
    }),

    breadcrumbs: [
      {
        title: intl.formatMessage({ id: 'breadcrumbs/professionals' }),
        href: '/professionals',
        as: '/professionals',
      },
      {
        title: intl.formatMessage({ id: 'breadcrumbs/professionals/downloads' }),
        href: '/professionals/downloads',
        as: '/professionals/downloads',
      },
    ],
  };

  const { dynamic_content } = getLocalizedObject(props).page || {};

  return (
    <LayoutPage {...pageProperties}>
      <LayoutPageHeading
        titleKey="page/professionals/downloads/listing/title"
        sublineKey="page/professionals/downloads/listing/subline"
      />

      {dynamic_content && (
        <Row gutter={[defaultHorizontalGutter, 40]}>
          <LayoutDynamicZone
            filter={LayoutDynamicZoneComponentTypes.Card}
            size={LayoutCardSize.Small}
            type={LayoutCardType.Overview}
            link="professionals/downloads"
            components={dynamic_content}
            groupCards={false}
          />
        </Row>
      )}
    </LayoutPage>
  );
};

export default ProfessionalsDownloadsListingPage;
